const MappingState = {
    MAPPED: "MAPPED",
    UNMAPPED: "UNMAPPED",
    MAPPED_AND_UNMAPPED: "MAPPED_AND_UNMAPPED"
}

export default MappingState
